import Icon, { Loading3QuartersOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useEffect, useMemo, useRef, useState } from 'react';

import FailedSvg from '@/components/Icon/svgs/fill-warning.svg';
import RightSvg from '@/components/Icon/svgs/right_share.svg';
import { useModel } from '@/hooks/useModel';

import AppearanceModal from './AppearanceModal';
import styles from './index.less';

interface IProps {
  className?: string;
}

const Appearance = (props: IProps) => {
  const { className } = props;
  const [open, setOpen] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const { userProfile, loadUserDetail } = useModel('auth-model', (model) => ({
    userProfile: model.userProfile,
    loadUserDetail: model.loadUserDetail
  }));

  const isAnalyzing = useMemo(() => {
    return !!(
      !!userProfile?.homepage?.cover &&
      userProfile.homepage.isQualifiedCover !== false &&
      userProfile.homepage.isQualifiedCover !== true
    );
  }, [userProfile]);

  useEffect(() => {
    if (isAnalyzing) {
      timerRef.current = setInterval(() => {
        loadUserDetail();
      }, 3000);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isAnalyzing]);

  const handleClick = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <div className={classNames(styles.container, className)} onClick={handleClick}>
        <img
          alt=""
          className={styles.img}
          src={userProfile?.homepage?.cover || userProfile?.avatar}
        />
        <div className={styles.text}>Appearance</div>
        {isAnalyzing ? (
          <Loading3QuartersOutlined className="text-[20px]" spin />
        ) : !userProfile?.homepage?.isQualifiedCover ? (
          <Icon
            className={'text-[20px] text-[#FF4743] bg-white shrink-0 rounded-[50%]'}
            component={FailedSvg}
          />
        ) : (
          <Icon className={styles.rightIcon} component={RightSvg} />
        )}
      </div>

      <AppearanceModal onCancel={handleCancel} open={open} />
    </>
  );
};

export default Appearance;
